import { keysToCamel } from "@/helpers/humps";
import { AppPropKeys, type AppProps } from "@/models/appProps";
import { API_BASE } from "@/services/api";

const isWorkerSSR = typeof window === "undefined";

export async function getAppProps(): Promise<AppProps> {
  const propKeys = Object.values(AppPropKeys);
  const params = new URLSearchParams();
  const key = propKeys.length > 1 ? "key[]" : "key";
  propKeys.forEach((k) => params.append(key, k));
  try {
    const init: RequestInit & {
      cf?: { cacheEverything?: boolean; cacheTtl?: number };
    } = {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    };
    if (isWorkerSSR) {
      init.signal = AbortSignal.timeout(2500);
      init.cf = {
        cacheEverything: true,
        cacheTtl: 600,
      };
    }
    const resp = await fetch(`${API_BASE}/app_prop?${params.toString()}`, init);
    if (!resp?.ok) {
      return Promise.resolve({});
    }
    const ap = (await resp.json()) as AppProps;
    return transformAppProps(ap);
  } catch (_e) {
    return {};
  }
}

const transformAppProps = (ap: AppProps): AppProps => {
  const mutableAp = ap as Record<string, boolean | string | undefined>;
  for (const [key, value] of Object.entries(ap)) {
    if (value === "true") {
      mutableAp[key] = true;
    } else if (value === "false") {
      mutableAp[key] = false;
    }
  }
  return keysToCamel(ap);
};
